import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import ClientContainer from '../../ClientContainer';
import ProjectsTable from './ProjectsTable';
import useGetNewProjectData from '../../../hooks/useGetNewProjectData';
import BannerStrip from '../../Common/Containers/BannerStrip';
import SwitchCheckbox from '../../Common/Controls/SwitchCheckbox';
import ProjectDetails from './projectDetails';
import useCloseDrawers from '../../../hooks/useCloseDrawers';
import { RootState } from '../../../../../redux/root';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';
import { ModalDefaultDraggable } from '../../../../../molecules';

const Projects = () => {
  useGetNewProjectData({ projects: true, activities: true });
  useCloseDrawers();
  const dispatch = useDispatch();
  const [checked, setChecked] = useState<boolean>(false);
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const selectedPermit = useSelector((s: RootState) => s.projectsSlice.selectedPermit);

  const onChange = e => {
    setChecked(e.target.checked);
  };

  const handleClose = () => dispatch(setShowDrawerContent(false));

  const title = selectedPermit?.name
    ? `${selectedPermit.name}${selectedPermit.permitName ? ` / ${selectedPermit.permitName}` : ''}`
    : 'Project Details';

  return (
    <ClientContainer>
      <BannerStrip label={!checked ? 'Active Projects' : 'All Projects'}>
        <ToggleWrap>
          <ToggleLabel>Show all projects</ToggleLabel>
          <SwitchCheckbox
            label=""
            checked={checked}
            name="showAll"
            value=""
            onChange={onChange}
            isRadio={false}
            disabled={false}
            title="Toggle to show all projects, including inactive ones"
          />
        </ToggleWrap>
      </BannerStrip>
      <TableStage>
        <ProjectsTable showActiveOnly={!checked} />
      </TableStage>
      {showDrawerContent && (
        <ModalDefaultDraggable title={title} onClose={handleClose} wide addContactModal>
          <ProjectDetails />
        </ModalDefaultDraggable>
      )}
    </ClientContainer>
  );
};

export default Projects;

const TableStage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const ToggleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ToggleLabel = styled.span`
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--neutral-700);
  letter-spacing: 0.01em;

  @media only screen and (max-width: 540px) {
    display: none;
  }
`;
